import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { ServicePlanItem } from 'src/features/servicePlanItems/utils/types';
import { ServicePlanItemFormSchemaValues } from 'src/features/servicePlanItems/utils/formSchema';

const RESOURCE = '/subscriptions/service-plan-item/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends ServicePlanItemFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<ServicePlanItem> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateServicePlanItem };
